import { request, nextStep } from "../assets/js/helper.js";

export const getProductAnswersArray = async (
  { commit },
  productAnswersUrlObject
) => {
  try {
    if (!productAnswersUrlObject) return;
    commit("setShowLoader", true);
    const response = await request(productAnswersUrlObject.url, {
      // headers: { "X-WP-Nonce": productAnswersUrlObject.nonce }
    });
    if (response) commit("setProductAnswersArray", response);
    return response;
  } catch (e) {
    console.error(e);
  } finally {
    commit("setShowLoader", false);
  }
};
export const getQuetionsArray = async ({ commit }, quetionsUrlObject) => {
  try {
    if (!quetionsUrlObject) return;
    commit("setShowLoader", true);
    const response = await request(quetionsUrlObject.url, {
      // headers: { "X-WP-Nonce": quetionsUrlObject.nonce }
    });
    if (response) commit("setQuestionsArray", response);
  } catch (e) {
    console.error(e);
  } finally {
    commit("setShowLoader", false);
  }
};
export const getAnswerMatrixArray = async ({ commit }, matrixUrlObject) => {
  try {
    if (!matrixUrlObject) return;
    commit("setShowLoader", true);
    const response = await request(matrixUrlObject.url, {
      // headers: { "X-WP-Nonce": matrixUrlObject.nonce }
    });
    if (response) commit("setMatrixArray", response);
  } catch (e) {
    console.error(e);
  } finally {
    commit("setShowLoader", false);
  }
};

// export const getProductImage = async ({ state }, media) => {
//   try {
//     if (!media) return;
//     // commit("setShowLoader", true);
//     const { quizRestUrls } = state;
//     const { mediaUrl } = quizRestUrls;
//     const response = await request(`${mediaUrl.url}/${media}`);

//     if (response) {
//       return response.source_url;
//     }
//   } catch (e) {
//     console.error(e);
//   } finally {
//     // commit("setShowLoader", false);
//   }
// };
export const getProductMetas = async (state, productMetaUrlObject) => {
  try {
    //console.log(productMetaUrlObject)
    const response = await request(productMetaUrlObject.url, {
      // headers: { "X-WP-Nonce": productMetaUrlObject.nonce }
    });
    return response;
  } catch (e) {
    console.error(e);
  } finally {
    // commit("setShowLoader", false);
  }
};
const generateAttributesUrl = attributes => {
  try {
    let attributesUrlParams = "?";

    attributes.forEach(attribute => {
      attributesUrlParams += `attributes[]=${attribute}&`;
    });
    return attributesUrlParams;
  } catch (e) {
    console.error(e);
  }
};

export const getAllData = async ({ dispatch, commit }, urlObject) => {
  try {
    if (!urlObject) return;
    const { questions, productAnswers, answerMatrix } = urlObject;
    commit("setQuizRestUrls", urlObject);
    await dispatch("getQuetionsArray", questions);
    await dispatch("getProductAnswersArray", productAnswers);
    await dispatch("getAnswerMatrixArray", answerMatrix);
  } catch (e) {
    console.error(e);
  }
};

export const setSiteData = ({ commit, dispatch }, quizData) => {
  try {
    if (!quizData) return;
    const {
      questions,
      quiz,
      settings,
      quizRestUrls,
      admin,
      userResults
    } = quizData;
    commit("setQuestionsArray", questions);
    commit("setSiteSettings", settings);
    commit("setQuizRestUrls", quizRestUrls);
    commit("setQuiz", quiz);
    commit("setAdmin", admin);

    if (userResults) {
      let { products } = userResults;
      if (typeof products === "string") {
        products = JSON.parse(products);
      }

      commit("setProducts", products);
      commit("setIsOwnerOfResults", false);
      dispatch("setEndingStep", 1);
    }
    if (questions) {
      commit("setCurrentStep", questions[0].id);
    }
  } catch (e) {
    console.error(e);
  }
};
export const setEndingStep = ({ state, commit }, ending) => {
  try {
    const { endingSteps } = state;
    commit("setEndingStep", endingSteps[ending]);
    commit("setShowLoader", false);

    commit("setShowSlidePostEnding", true);
  } catch (e) {
    console.error(e);
  }
};

export const generateProducts = async ({ dispatch, state, commit }) => {
  try {
    commit("setShowLoader", true);

    const {
      userAnswers,
      quizRestUrls,
      user,
      quiz,
      productMetaToShow,
      admin
    } = state;
    const { generateProducts } = quizRestUrls;
    const { url } = generateProducts;
    const attrubutesUrl = generateAttributesUrl(productMetaToShow);
    const form = new FormData();
    form.append("user", JSON.stringify(user));
    form.append("answers", JSON.stringify(userAnswers));
    form.append("quiz_id", quiz);
    form.append("is_admin", admin);
    const response = await request(`${url}${attrubutesUrl}`, {
      // headers: { "X-WP-Nonce": nonce },
      body: form,
      method: "POST"
    });
    if (response) {
      commit("setProducts", response.products);
      if (response.debug) {
        commit("setDebugInfo", response.debug);
      }

      if (response.nonce) {
        commit("setNonce", response.nonce);
      }

      if (response.shareLinks) {
        commit("setShareLinks", response.shareLinks);
      }
      commit("resetRetries");
      // commit("updateGenerateNonce", response.nonce);
    }
    dispatch("setEndingStep", 1);
    return;
  } catch (e) {
    try {
      if (e.message === "reauth" && state.retries) {
        await dispatch("reAuth", { userLoader: false });
        await dispatch("generateProducts");
      } else {
        commit("setShowSlidePostEnding", false);
      }
    } catch (e) {
      console.error(e);
    }
    console.error(e);
  } finally {
    commit("setShowLoader", false);
  }
};
export const addProductToCart = async (
  { dispatch, state, commit },
  productId
) => {
  try {
    commit("setDisableUser", true);
    const { quizRestUrls } = state;
    const { addProductToCart } = quizRestUrls;
    const { url } = addProductToCart;
    const form = new FormData();
    form.append("product_id", JSON.stringify(productId));
    const response = await request(url, {
      // headers: { "X-WP-Nonce": nonce },
      body: form,
      method: "POST"
    });
    if (response) {
      commit("updateOneProduct", {
        id: productId,
        addedToCart: response.success
      });
      if (response.success) {
        try {
          const cartIcon = document.querySelector(".mk-header-cart-count");
          let cartTotal = parseInt(cartIcon.innerText);
          if (cartTotal) {
            cartTotal++;
          }
          cartIcon.innerText = cartTotal;
        } catch (e) {
          console.error(e);
        }
      }
      if (response.nonce) {
        commit("setNonce", response.nonce);
      }
      commit("resetRetries");
    }
    return;
  } catch (e) {
    try {
      if (e.message === "reauth" && state.retries) {
        await dispatch("reAuth", {});
        await dispatch("addProductToCart", productId);
      }
    } catch (e) {
      console.error(e);
    }
  } finally {
    commit("setDisableUser", false);
  }
};

export const reAuth = async (
  { state, commit },
  { userLoader = true, reduceRetry = true }
) => {
  try {
    if (userLoader) {
      commit("setDisableUser", true);
    } else {
      commit("setShowLoader", true);
    }
    if (reduceRetry) {
      commit("reduceRetries");
    }
    const { quizRestUrls } = state;
    const { reAuth } = quizRestUrls;
    const { url } = reAuth;
    const response = await request(url, {
      method: "GET"
    });
    if (response) {
      if (response.nonce) {
        commit("setNonce", response.nonce);
        return true;
      }
    }
    return false;
  } catch (e) {
    console.error(e);
  } finally {
    if (userLoader) {
      commit("setDisableUser", false);
    } else {
      commit("setShowLoader", false);
    }
  }
};

export const storeAnsweredQuestion = async (
  { state, commit, dispatch },
  answerObject
) => {
  try {
    
    commit("setShowLoader", true);
    if (!answerObject) return;

    const { questionsArray, siteSettings,currentStep } = state;
    const currentQuestion = questionsArray.find(question=>question.id==currentStep)
    if(!currentQuestion) {
      return 
    }
    if (currentQuestion.required){
      if(
        (typeof answerObject.answerIndex !== 'number' && 
        !Array.isArray(answerObject.answerIndex)) || 
        (Array.isArray(answerObject.answerIndex) && !answerObject.answerIndex.length)) {
      return;
    }
  }
    console.log(currentQuestion.required,typeof answerObject.answerIndex ,answerObject)
    commit("storeAnsweredQuestion", answerObject);
    const nextStepObject = nextStep(currentStep, questionsArray);
    if (!nextStepObject) {
      //   make request here
      const { leadCaptureFields } = siteSettings;
      if (
        siteSettings.leadCapture &&
        leadCaptureFields &&
        (leadCaptureFields.email.enable || leadCaptureFields.name.enable)
      ) {
        dispatch("setEndingStep", 0);
      } else {
        await dispatch("generateProducts");
      }
      return;
    }

    const nextCurrentStep = nextStepObject.id;
    commit("setCurrentStep", nextCurrentStep);
  } catch (e) {
    console.error(e);
  } finally {
    commit("setShowLoader", false);
  }
};

export const storeMultiAnsweredQuestion = async (
  { commit, dispatch },
  answerArray
) => {
  try {
    if (!Array.isArray(answerArray)) return;
    
    const answerObject = {};
    if(answerArray.length){
      answerObject.questionId = answerArray[0].questionId;
      answerObject.answerIndex = answerArray.map(answer => answer.answerIndex);
    }
    dispatch("storeAnsweredQuestion", answerObject);
  } catch (e) {
    console.error(e);
  } finally {
    commit("setShowLoader", false);
  }
};
